import { removeAuth } from "src/app/util/auth";
import { environment } from "src/environments/environment";

export function errorHandler(err: any) {
  console.log('error occured')
  console.log(err)
  if (err.status == 401) {
    removeAuth();
    location.href = `${environment.FRONTEND_BASE_URL}schoolportal/login`;
  }

  return {
    error: true,
    message:
      err?.error?.ExceptionMessage ||
      err?.error?.Message ||
      err?.Message ||
      "An error occurred.",
  };
}
